import React from "react";
import numbro from "numbro";
import PoItem from "./poDesktopItem";

const PoContentsDesktop = ({ contents }) => {
    const total = contents.reduce((sum, item) => sum + (item.payable_paisas || 0), 0);
    const totalPkr = numbro(total / 100).format({ thousandSeparated: true, mantissa: 2 });

    return (
        <div className="d-none d-md-block">
            <table className="w-100 po-table" style={{ tableLayout: 'auto', borderCollapse: 'collapse' }}>
                <colgroup>
                    <col style={{ width: '6%' }} />
                    <col style={{ width: '48%' }} />
                    <col style={{ width: '23%' }} />
                    <col style={{ width: '23%' }} />
                    <col style={{ width: '1%' }} />
                </colgroup>
                <thead>
                    <tr className="tbl-header-font align-bottom" style={{ borderBottom: '2px solid #4caf50' }}>
                        <th className="pb-1"></th>
                        <th className="text-start pb-1" style={{ fontWeight: 'inherit' }}>SKU</th>
                        <th className="text-end pb-1" style={{ fontWeight: 'inherit' }}>Price</th>
                        <th className="text-end pb-1" style={{ fontWeight: 'inherit' }}>Quantity</th>
                        <th className="text-end pb-1" style={{ fontWeight: 'inherit' }}>Payable</th>
                    </tr>
                </thead>
                <tbody>
                    {contents.map((item, index) => (
                        <PoItem index={index} poItem={item} key={index} />
                    ))}
                    <tr>
                        <td colSpan={3}></td>
                        <td colSpan={2} className="text-end" style={{ paddingTop: '1.5rem' }}>
                            <div style={{ fontWeight: '600', fontSize: '18px', color: '#000', lineHeight: '1' }}>
                                PKR {totalPkr}
                            </div>
                            <div style={{ marginTop: '2px', fontSize: '12px', color: '#616E7C', fontWeight: 400, lineHeight: '1.3' }}>
                                Total payable
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

export default PoContentsDesktop;
